import { combineReducers } from 'redux';
// slices
import pathwayReducer from '../pages/pathways-page/slice';
import sharedPathwayReducer from '../pages/explore-pathway-shared-page/slice';
import topicSuggestionReducer from '../features/@topic-suggestion/slice';
import builderReducer from '../features/pathway-builder/slice';
import exploreReducer from '../pages/explore-pathways-page/slice';
import invitationReducer from '../features/invitation/slice';
import followingReducer from '../pages/explore-pathway-following-page/slice';
import exploreDetailsReducer from '../pages/explore-pathway-view-page/slice';
import pathwayFollowingViewerReducer from '../pages/explore-pathway-following-viewer-page/slice';
import pathwaySharedViewerReducer from '../pages/explore-pathway-shared-viewer-page/slice';
import personalLearningReducer from '../pages/personal-learning-page/slice';
import createReducer from '../pages/pathway-create-page/slice';
import suggestionsReducer from '../pages/suggestions-page/slice';
import circleReducer from '../pages/circles-page/slice';
import circleActivityReducer from '../pages/circle-activity-page/slice';
import circleCreateReducer from '../pages/circle-create-page/slice';
import circleDetailsReducer from '../pages/circle-details-page/slice';
import aiChatReducer from '../features/ai-chat/slice';
import topicCommentsReducer from '../features/topic-comments/slice';
import upNextReducer from '../pages/up-next-page/slice';
import completedTopicsReducer from '../pages/completed-topics-page/slice';
import externalPlatformsReducer from '../pages/external-platforms-page/slice';
import organizationContextReducer from '../features/organization-context/slice';
import adminReducer from '../_admin-pages/slice';
import adminOrganizationsReducer from '../_admin-pages/organizations/slice';
import adminOrganizationDetailReducer from '../_admin-pages/organization-details/slice';
import tiptapToolbarReducer from '../components/editor/tiptap/slice';
import topicEditReducer from '../pages/topic-edit-single-page/slice';
import flashcardReviewReducer from '../pages/flashcard-review-page/slice';
import orgOverviewReducer from '../_org-pages/overview/slice';
import orgMembersReducer from '../_org-pages/members/slice';
import orgCirclesReducer from '../_org-pages/circles/slice';
import orgCircleCreateReducer from '../_org-pages/circle-create/slice';
import orgPathwaysReducer from '../_org-pages/pathways/slice';
import orgInvitationReducer from '../pages/invitation/slice';
import sidebarPeersReducer from '../features/sidebar-peers/slice';
import userReducer from './slices/user';

const rootReducer = combineReducers({
  user: userReducer,
  pathway: pathwayReducer,
  sharedPathways: sharedPathwayReducer,
  builder: builderReducer,
  topicSuggestion: topicSuggestionReducer,
  explore: exploreReducer,
  invitation: invitationReducer,
  following: followingReducer,
  exploreDetails: exploreDetailsReducer,
  pathwayFollowingViewer: pathwayFollowingViewerReducer,
  pathwaySharedViewer: pathwaySharedViewerReducer,
  personalLearning: personalLearningReducer,
  create: createReducer,
  suggestions: suggestionsReducer,
  circle: circleReducer,
  circleActivity: circleActivityReducer,
  circleCreate: circleCreateReducer,
  circleDetails: circleDetailsReducer,
  aiChat: aiChatReducer,
  topicComments: topicCommentsReducer,
  upNext: upNextReducer,
  completedTopics: completedTopicsReducer,
  externalPlatforms: externalPlatformsReducer,
  organizationContext: organizationContextReducer,
  admin: adminReducer,
  adminOrganizations: adminOrganizationsReducer,
  adminOrganizationDetail: adminOrganizationDetailReducer,
  tiptapToolbar: tiptapToolbarReducer,
  topicEdit: topicEditReducer,
  flashcardReview: flashcardReviewReducer,
  orgOverview: orgOverviewReducer,
  orgMembers: orgMembersReducer,
  orgCircles: orgCirclesReducer,
  orgCircleCreate: orgCircleCreateReducer,
  orgPathways: orgPathwaysReducer,
  orgInvitation: orgInvitationReducer,
  sidebarPeers: sidebarPeersReducer
});

export { rootReducer };
